import { IoArrowUp, IoArrowDown } from 'react-icons/io5';
import Lottie from 'lottie-react';
import React, { useEffect, useState } from 'react';

import Loader from '../img/car_loading.json';

const FinalAgreement = ({
  clearSignature,
  handleAccept,
  showScrollTop,
  handleScroll,
  scrollToTop,
  scrollToBottom,
  BookingAgreement,
  termsRef,
  isAccepted,
  signRef,
  loading,
  finalAgreementChecklist,
}: {
  clearSignature: any;
  handleAccept: any;
  showScrollTop: any;
  handleScroll: any;
  scrollToTop: any;
  scrollToBottom: any;
  BookingAgreement: any;
  termsRef: any;
  isAccepted: any;
  signRef: any;
  loading: boolean;
  finalAgreementChecklist: any;
}) => {
  useEffect(() => {
    const modalElement = document.getElementById('final_agreement');

    const handleShown = () => {
      scrollToTop?.();
    };

    if (modalElement) {
      modalElement.addEventListener('shown.bs.modal', handleShown);
    }

    return () => {
      if (modalElement) {
        modalElement.removeEventListener('shown.bs.modal', handleShown);
      }
    };
  }, [scrollToTop]);

  const [checkedItems, setCheckedItems] = useState<{ [key: string]: boolean }>(
    {}
  );

  const handleCheckboxChange = (id: number) => {
    setCheckedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const allChecked =
    finalAgreementChecklist &&
    finalAgreementChecklist.length > 0 &&
    finalAgreementChecklist.every((item: any) => checkedItems[item.id]);

  return (
    <>
      {/* <div
        className="modal fade final-agreement-modal"
        id="final_agreement"
        role="dialog"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content py-0">
            <div className="modal-body pt-0">
              <div className="row">
                <div className="col-2"></div>
                <div className="col-8 text-center"></div>
                <div className="col-2 d-flex justify-content-end">
                  <span
                    className="align-center text-black fs-xx-large"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    aria-hidden="true"
                    style={{ cursor: "pointer" }}
                  >
                    ×
                  </span>
                </div>
              </div> */}

      {loading ? (
        <>
          <div className="d-flex justify-content-center">
            <Lottie
              animationData={Loader}
              loop={true}
              style={{ width: 100, height: 100 }}
            />
          </div>
        </>
      ) : (
        <div className="relative">
          <div
            ref={termsRef}
            onScroll={handleScroll}
            className="scroll-box border p-3"
            style={{
              height: `calc(45vh + 0rem)`,
              overflowY: 'auto',
            }}
          >
            <h6 className="text-center fw-bolder my-3">
              FAIRPY RENTAL CAR AGREEMENT
            </h6>
            <BookingAgreement />
          </div>

          <div className="float-end ">
            {showScrollTop ? (
              <div
                onClick={scrollToTop}
                style={{
                  marginTop: '-3rem',
                  marginLeft: '-3rem',
                  zIndex: 999,

                  position: 'absolute',
                }}
              >
                <IoArrowUp className="text-primary  fs-40" />
              </div>
            ) : (
              <div
                onClick={scrollToBottom}
                style={{
                  marginTop: '-3rem',
                  marginLeft: '-3rem',
                  zIndex: 999,

                  position: 'absolute',
                }}
              >
                <IoArrowDown className="text-primary  fs-40" />
              </div>
            )}
          </div>

          { (
            <>
              <div className="py-2">
                <p>
                  By signing, you confirm that you have read, understood, and
                  acknowledged all checklist items, and you consent to begin the
                  ride
                </p>

                {finalAgreementChecklist?.map((item: any, index: string) => {
                  return (
                    <p className="d-flex" key={index}>
                      <input
                        type="checkbox"
                        name={item.name}
                        className={`mb-0 me-2`}
                        checked={!!checkedItems[item.id]}
                        onChange={() => handleCheckboxChange(item.id)}
                      />
                      {item.instruction_text}
                    </p>
                  );
                })}
              </div>
              <div className="signature-area">
                <canvas ref={signRef} className="border p-3" />
              </div>

              <div className="text-center mt-3">
                {allChecked && isAccepted && (
                  <button
                    type="button"
                    className="btn bg-primary text-white me-1"
                    onClick={handleAccept}
                      disabled={!isAccepted}
                  >
                    I Accept
                  </button>
                )}

                <button
                  type="button"
                  className="btn btn-secondary me-1"
                  onClick={clearSignature}
                >
                  Clear
                </button>
              </div>
            </>
          )}
        </div>
      )}
      {/* </div>
          </div>
          </div>
       </div> */}
    </>
  );
};

export default FinalAgreement;
